import React from 'react'
import Vector from "../../assets/images/Vector.png";
import Group from "../../assets/images/Group.png";
import styled from "styled-components";
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../assets/css/section.css'
const LeftImageContainer = styled.div`
  position: absolute;
  bottom: 50px;
  z-index: 1;
`;

const RightImageContainer = styled.div`
  position: absolute;
  bottom: 12px;
  right: 3px;
`;
interface Section2 {

}
const Section2  : React.FunctionComponent<Section2> = (props) => {
  return (
    <div className='indicabout20' style={{position:'relative',background:'white'}}>
         <div className="container modrenHealth" >
            <div className="row">
            <div className="col-lg-12 col-xl-12 text-center">
            <h2 className='myindici-heading myindicitext'>myindici 2.0</h2>
            <h4 className='h1-text1 pb-0'>An effortless way to interact with your healthcare.</h4>
            </div>
            <div className="col-lg-12 col-xl-12 text-center ">
            <p className='para  px-sm-2  pl-5 pr-1'>
              myindici 2.0 is the latest version of our revolutionary patient
              portal, enabling you to instantly access your healthcare whenever
              you need. Take advantage of myindici's intuitive features to
              easily book appointments, request repeat prescriptions, view your
              health record, and so much more.
            </p>
            </div>
            </div>
      </div>
      <LeftImageContainer>
      <img src={Vector} alt="" style={{}} />
      </LeftImageContainer>
      <RightImageContainer>
      <img src={Group} alt="" />
      </RightImageContainer>
    </div>
  )
}

export default Section2